interface ValidateResponse {
  valid: boolean;
}

export async function validateScopes(): Promise<boolean> {
  const response = await fetch("/backend/validate-scopes");
  const parsedResponse = (await response.json()) as ValidateResponse;
  return parsedResponse.valid;
}
